module.exports = __webpack_public_path__ + "img/icon-1.6f936503.png";